(() => {
  const SECTION_SELECTOR = '[data-family-stats]';
  const COUNTER_SELECTOR = '[data-family-counter]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const parseCounter = (text) => {
    const source = String(text || '');
    const match = source.match(/-?\d(?:[\d\s,.]*\d)?/);

    if (!match) return null;

    const rawNumber = match[0];
    const normalized = rawNumber.replace(/[^\d.-]/g, '');
    const target = parseInt(normalized, 10);

    if (!Number.isFinite(target)) return null;

    let separator = '';
    if (rawNumber.includes(',')) {
      separator = ',';
    } else if (/[\s\u00a0]/.test(rawNumber)) {
      separator = ' ';
    }

    return {
      prefix: source.slice(0, match.index),
      suffix: source.slice(match.index + rawNumber.length),
      separator,
      target
    };
  };

  const formatNumber = (value, separator) => {
    const rounded = Math.max(0, Math.round(value));
    const plain = String(rounded);

    if (!separator) return plain;

    return plain.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  };

  const renderCounter = (element, pattern, value) => {
    element.textContent = `${pattern.prefix}${formatNumber(value, pattern.separator)}${pattern.suffix}`;
  };

  const prepareCounter = (element) => {
    if (element.dataset.familyCounterReady === 'true') {
      return;
    }

    const original = element.textContent;
    const pattern = parseCounter(original);

    if (!pattern) {
      element.dataset.familyCounterReady = 'true';
      return;
    }

    element.dataset.familyCounterReady = 'true';
    element.familyCounterPattern = pattern;

    if (!reduceMotion.matches) {
      renderCounter(element, pattern, 0);
    }
  };

  const animateCounter = (element, duration) => {
    const pattern = element.familyCounterPattern;

    if (!pattern || element.dataset.familyCounterPlayed === 'true') {
      return;
    }

    element.dataset.familyCounterPlayed = 'true';

    if (reduceMotion.matches) {
      renderCounter(element, pattern, pattern.target);
      return;
    }

    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      renderCounter(element, pattern, pattern.target * eased);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        renderCounter(element, pattern, pattern.target);
      }
    };

    window.requestAnimationFrame(tick);
  };

  const playSection = (section) => {
    const duration = parseInt(section.dataset.counterDuration, 10) || 1400;

    section.querySelectorAll(COUNTER_SELECTOR).forEach((counter) => {
      animateCounter(counter, duration);
    });
  };

  const prepareSection = (section) => {
    if (!section || section.dataset.familyStatsReady === 'true') {
      return;
    }

    section.dataset.familyStatsReady = 'true';
    section.querySelectorAll(COUNTER_SELECTOR).forEach(prepareCounter);

    if (!('IntersectionObserver' in window)) {
      playSection(section);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        playSection(section);
        observer.unobserve(section);
      });
    }, {
      threshold: 0.32,
      rootMargin: '0px 0px -8% 0px'
    });

    observer.observe(section);
  };

  const init = (root = document) => {
    if (root.matches && root.matches(SECTION_SELECTOR)) {
      prepareSection(root);
    }

    root.querySelectorAll(SECTION_SELECTOR).forEach(prepareSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
